import usePWAInstall from '../../hooks/usePWAInstall';

export default function PWAInstallPrompt({ appName = 'App', appIconSrc = '/favicon.png' }) {
  const { showPrompt, isInstalling, isInstalled, isIOS, isInstallable, install, dismiss } = usePWAInstall();

  if (!showPrompt || !isInstallable || isInstalled) return null;

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-label={`Install ${appName}`}
      className="fixed z-[90] top-[calc(env(safe-area-inset-top,0px)+4.25rem)] sm:top-[calc(env(safe-area-inset-top,0px)+5rem)] right-3 sm:right-4 lg:right-8 left-3 sm:left-auto animate-slide-down pointer-events-none"
    >
      <div className="pointer-events-auto sm:w-96 ml-auto bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-lg flex items-center gap-3 p-3">
        {appIconSrc && (
          <div className="w-11 h-11 rounded-xl overflow-hidden shrink-0 bg-gray-50 dark:bg-gray-800 flex items-center justify-center">
            <img src={appIconSrc} alt="" className="w-full h-full object-cover" aria-hidden="true" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">{appName}</p>
          <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
            {isIOS ? (
              <>Tap <strong className="font-medium text-gray-600 dark:text-gray-300">Share</strong>, then <strong className="font-medium text-gray-600 dark:text-gray-300">Add to Home Screen</strong></>
            ) : (
              "Tap Install, then confirm in your browser's popup"
            )}
          </p>
        </div>

        {!isIOS && (
          <button
            onClick={install}
            disabled={isInstalling}
            className="shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold text-white bg-gov-blue hover:bg-gov-blue/90 active:scale-[0.98] disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200"
          >
            {isInstalling ? (
              <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
            ) : (
              'Install'
            )}
          </button>
        )}

        <button
          onClick={dismiss}
          aria-label="Dismiss"
          className="shrink-0 p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors duration-200"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <style>{`
        @keyframes slideDown {
          from { transform: translateY(-100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slide-down {
          animation: slideDown 0.35s cubic-bezier(0.16, 1, 0.3, 1);
        }
      `}</style>
    </div>
  );
}
